import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

//TODO: Use this common component in every component with a help icon tooltip
import { jsx as _jsx } from "react/jsx-runtime";
export function Asterisk() {
  var theme = useTheme();
  return /*#__PURE__*/_jsx(Typography, {
    className: "required-asterisk",
    color: theme.palette.error[600],
    variant: "text-sm-medium",
    "data-element": "Typography",
    "data-component": "Asterisk",
    "data-source-file": "Astreisk.tsx",
    children: "*"
  });
}